import {baseAxios} from '@mc/axios-api';
import * as Api from './gen/api';

let baseURL = '';
export * from './gen/configuration';
export * from './gen/model';
/*if ((window as any).appConfig && (window as any).appConfig.serverContextPath !== undefined) {
    baseURL = (window as any).appConfig.serverContextPath;
} else if ((window as any).serverContextPath !== undefined) {
    baseURL = (window as any).serverContextPath;
}*/

export const SoudniSporyApi = new Api.SoudniSporyControllerApi(undefined, baseURL, baseAxios);

export {Api};
